import styled from "styled-components";

import { SubmitButton } from "shared/ui/ecosystems/forms";

export const ContinueButton = styled(SubmitButton)`
  width: 180px;
`;
